import { useEffect, useLayoutEffect } from 'react';
import { IS_CLIENT } from '../../constants/common';
export const useClientLayoutEffect = IS_CLIENT ? useLayoutEffect : useEffect;
